import React from 'react';
import PropTypes from 'prop-types';
import Title from '../base/Title/Title';
import OverviewTable from '../base/Table/OverviewTable';
import OverviewTableRow from '../base/Table/OverviewTableRow';
import MomentOverview from '../base/MomentOverview/MomentOverview';
import textTranslates from './translate.json';
import Moment from 'moment';

const ComplaintPreviewHeaderOverview = (props) => {
    return(
        <div id="complaintHeader">
            <Title
                id="complaintHeaderTitle"
                title={textTranslates.complaintHeaderTitle}/>
            <OverviewTable tableId="complaintHeaderTable">
                <tbody>
                    {props.complaint.number !=="" &&
                    <OverviewTableRow
                        id="complaintNumber"
                        label={textTranslates.complaintNumber}
                        value={props.complaint.number}/>
                    }
                    {/* <OverviewTableRow
                        id="complaintType"
                        label={textTranslates.complaintType}
                        value={props.complaint.complaintType.displayName}/> */}
                    <OverviewTableRow
                        id="complaintDate"
                        label={textTranslates.complaintDate}>
                        <MomentOverview moment={props.complaint.createDate} />
                    </OverviewTableRow>
                    <OverviewTableRow
                        id="erpStatus"
                        label={textTranslates.erpStatus}
                        value={props.complaint.erpStatus}>
                    </OverviewTableRow>
                </tbody>
            </OverviewTable>
        </div>
    );
};

ComplaintPreviewHeaderOverview.propTypes = {
    complaint: PropTypes.shape({
        complaintType: PropTypes.shape({
            displayName: PropTypes.string
        }),
        number: PropTypes.string
        
    })
};

export default ComplaintPreviewHeaderOverview;


// WEBPACK FOOTER //
// ./src/components/ComplaintPreview/ComplaintPreviewHeaderOverview.js